import React from 'react';
import { translate } from 'react-i18next';

import {Link} from 'react-router-dom';
import {Button, Form, Input, Grid, Header, Message, Label, Segment} from 'semantic-ui-react';

var style = {
    content: {
        height: '100%'
    },
    column: {
        maxWidth: '400px'
    },
    information: {
        content: '',
        clear: 'both',
        display: 'table',
        width: '100%'
    },
    errorLabel: {
        margin: '0'
    },
    field: {
    }
};

const ChoosePassword = ({t,
                         userName,
                         token, 
                         password, 
                         passwordConfirm, 
                         formAction, 
                         onSubmit, 
                         onPasswordChange, 
                         onPasswordConfirmChange, 
                         passwordError, 
                         passwordConfirmError, 
                         error}) => (
        <Grid style={style.content} textAlign="center" verticalAlign="middle">
            <Grid.Column style={style.column}>
                <Form noValidate method="POST" action={formAction} onSubmit={onSubmit}>
                    <Segment>
                    <Form.Field style={style.field}>        
                        <Form.Input 
                            fluid
                            type="password"
                            name="new_password"
                            icon="lock"
                            iconPosition="left"
                            value={password}
                            error={passwordError.length>0}
                            onChange={onPasswordChange}
                            placeholder={t('New Password')}
                            required
                        />
                        {passwordError.length > 0 &&
                            <Label basic color="red" pointing style={style.errorLabel}>{passwordError}</Label>
                        }
                    </Form.Field>        
                    <Form.Field style={style.field}>        
                        <Form.Input 
                            fluid
                            type="password"
                            name="userPassword2"
                            icon="lock"
                            iconPosition="left"
                            value={passwordConfirm}
                            error={passwordConfirmError.length>0}
                            onChange={onPasswordConfirmChange}
                            placeholder={t('Confirm Password')}
                            required
                        />
                        {passwordConfirmError.length > 0 &&
                            <Label basic color="red" pointing style={style.errorLabel}>{passwordConfirmError}</Label>
                        }
                    </Form.Field>        
                    {error &&
                        <Message negative>{error}</Message>
                    }
                    <Button type="submit" fluid color="teal">{t('Submit')}</Button>
                    </Segment>        


                    <input name='utf-8'                         type='hidden' value='?' />
                    <input name="username"    id="username"     type="hidden" value={userName} />
                    <input name="token"       id="token"        type="hidden" value={token} />
                </Form>
            </Grid.Column>
        </Grid>
  );

export default translate('authentication')(ChoosePassword);



// WEBPACK FOOTER //
// ./src/modules/authentication/ChoosePassword.js